// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__JHmPX","Logo":"Toolbar_Logo__263sM","DesktopOnly":"Toolbar_DesktopOnly__lP7I9"};